/*******************************************************************************
  설  명 : 정보센터 > 입찰정보
  작성자 : 송영석
  작성일 : 2020-06-08
*******************************************************************************/
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { CommonService } from '@app/service/common.service';
import { HMemberService } from '@home/service/member.service';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

@Component({
  selector: 'app-information-bidding',
  templateUrl: './information-bidding.component.html',
  styleUrls: ['./information-bidding.component.scss']
})
export class InformationBiddingComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public tabIndex: number = 0;
  page = 1;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private member: HMemberService,
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);
  }

  ngOnInit(): void {
  }

}
